import VideoEmdedCode from 'containers/Slices/VideoEmdedCode';
import YoutubeVideo from 'containers/Slices/YoutubeVideo';

export const seriesVideoTab = (block, type, index) => {
  switch (type) {
    case 'youtube_video':
      return <YoutubeVideo block={block} key={`${type}-${index}`} />;
    case 'youtube_embed_code':
      return <VideoEmdedCode block={block} key={`${type}-${index}`} />;
    default:
      return '';
  }
};
